import { render, staticRenderFns } from "./logistics-plus-charges.vue?vue&type=template&id=2edd5164&"
import script from "./logistics-plus-charges.vue?vue&type=script&lang=js&"
export * from "./logistics-plus-charges.vue?vue&type=script&lang=js&"
import style0 from "./logistics-plus-charges.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports